import { IonContent, IonPage, IonCol, IonRow, IonText, IonGrid, IonList, IonItem, IonLabel, IonIcon, IonCard, IonCardContent, IonInput, IonButton, IonSpinner, IonPopover, IonTextarea } from '@ionic/react';
import React, { useContext, useEffect, useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './FellowshipGroupProfilePage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { people } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import { UserRouteInfo, UserRouteKeys } from '../../routes/UserRoutes';
import { useDispatch, useSelector } from 'react-redux';
import { SelectCurrentUser } from '../../store/UserSlice';
import ServerDBContext from '../../components/ServerDBContext/ServerDBContext';
import { SelectGroup, SelectGroupIds, UpdateGroup } from '../../store/FellowshipSlice';
import ResetPassword from '../../components/ResetPassword/ResetPassword';
import ReadingPlanRecordService from '../../services/ReadingPlanRecordService';
import { SelectReadingPlans, UpdateActivePlanByIdAsync } from '../../store/BibleStudySlice';

const FellowshipGroupProfilePage: React.FC<IRouteInfo> = (props: IRouteInfo) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentUser = useSelector(SelectCurrentUser);
  const currentGroup = useSelector(SelectGroup);
  const readingPlans = useSelector(SelectReadingPlans); 
  const userGroupsIds = useSelector(SelectGroupIds);
  const [updateMessage, setUpdateMessage] = useState('');
  const [groupName, setGroupName] = useState('');
  const [groupDescription, setGroupDescription] = useState('');
  const dbService = useContext(ServerDBContext);
  const [displayResetPassword, setDisplayResetPassword] = useState(false);

  const saveProfile = () => {
    const updatedGroup =  {...currentGroup, name: groupName, description: groupDescription };
    setUpdateMessage('UPDATING GROUP PROFILE');
    dbService?.updateGroup(updatedGroup).then(result => { 
      if(result.Success) {
        dispatch(UpdateGroup(updatedGroup));
        // Update group reading plans Name
        const groupReadingPlan = readingPlans.find(plan => plan.groupId === result.Data?.id);
        if(groupReadingPlan) {
          ReadingPlanRecordService.getReadingPlanRecord(groupReadingPlan.id).then(getResult => {
            if(getResult.Success) {
              const updatedPlan = getResult.Data!;
              updatedPlan.name = groupName;
              ReadingPlanRecordService.updateReadingPlanRecord(updatedPlan).then(updateResult => {
                if(updateResult.Success) {
                  setUpdateMessage('SUCCESSFULLY UPDATED');
                  UpdateActivePlanByIdAsync(dispatch, userGroupsIds);
                } else {
                  setUpdateMessage('ERROR: GROUP UPDATED BUT GROUP PLAN FAILED');
                }
              }) 
            }
          });
        } else {
          setUpdateMessage('SUCCESSFULLY UPDATED');
        }

      } else {
        setUpdateMessage('ERROR: FAILED TO UPDATE');
      }
    })
  }

  useEffect(() => {
    setGroupName(currentGroup.name);
    setGroupDescription(currentGroup.description);
  }, [currentGroup])
  
  const pageHeaderMenuContent =
    <IonList className="fellowship-page-menu-list">
      <IonItem className="header-menu-item" onClick={() => history.push(UserRouteInfo[UserRouteKeys.FellowshipGroup].path.replace('/:nav?', ''), { direction: 'forward' })}>
        <IonLabel>GROUP DETAILS</IonLabel>
        <IonIcon slot="start" icon={people}></IonIcon>
      </IonItem>
    </IonList>;


  return (
    <IonPage>
      <PageHeader {...props} showBackButton={true} menuContents={pageHeaderMenuContent}></PageHeader>
      <IonContent className="fellowship-content">
        <IonGrid fixed={true}>
          <IonRow >
            <IonCol>
              <IonCard className="fellowship-profile-card" mode="md">
                  <IonCardContent>
                    <IonList className="profile-list-items">
                      <IonItem>
                        <IonInput label='NAME:' labelPlacement="stacked" value={groupName} onIonChange={e => setGroupName(e.detail.value?.toString()!)}></IonInput>
                      </IonItem>
                      <IonItem>
                        <IonTextarea  label='DESCRIPTION:' labelPlacement="stacked"
                           autoGrow={true} spellCheck={true} value={groupDescription} onIonChange={e => setGroupDescription(e.detail.value?.toString()!)}></IonTextarea>
                      </IonItem>
                    </IonList>
                    {
                      updateMessage === 'UPDATING PROFILE' ? 
                        <IonText className="login-message" color="primary">
                          <IonSpinner name="dots" color="primary"/><br />
                          {updateMessage}
                        </IonText> : 
                      updateMessage === 'SUCCESSFULLY UPDATED' ?
                        <IonText className="login-message" color="success">
                          {updateMessage}
                        </IonText> :
                        <IonText className="login-message" color="danger">
                          {updateMessage}
                        </IonText> 
                    }
                    <IonButton color="tertiary" expand="block" onClick={saveProfile}>
                      <IonLabel>
                        SAVE PROFILE
                      </IonLabel>
                    </IonButton>
                  </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>
        </IonGrid>
        <IonPopover
          mode="md"
          isOpen={displayResetPassword}
          onDidDismiss={() => {
              setDisplayResetPassword(false);
          }}
        > 
          <ResetPassword email={currentUser.email} />
      </IonPopover>
      </IonContent>
    </IonPage>
  );
};

export default FellowshipGroupProfilePage;